import { gql, GraphQLClient } from 'graphql-request';
import {
  endPoint,
  merchantServiceGraphql,
  tokenAppGraphql,
  userToken,
} from '../config/Config';

export const getMerchantByID = async (id) => {
  const MERCHANT_BY_ID = gql`
    query Merchant($merchantId: Int!) {
      Merchant(id: $merchantId) {
        id
        brc_number
        name
        type
        country
        brand
        industry
        status
        employeeID
        mdrID
        created_at
        updated_at
        brc_image_path
        apollo_submerchant {
          id
          merchantID
          submerchantID
          name
          state
          city
          phone
          email
          address
        }
      }
    }
  `;

  const response = await merchantServiceGraphql.request(MERCHANT_BY_ID, {
    merchantId: id,
  });
  return response.Merchant;
};

export const getMerchantName = async (id) => {
  try {
    const MERCHANT = gql`
      query Merchant($merchantId: Int!) {
        Merchant(id: $merchantId) {
          name
        }
      }
    `;
    const response = await merchantServiceGraphql.request(MERCHANT, {
      merchantId: id,
    });
    return response.Merchant.name;
  } catch (err) {
    return null;
  }
};

export const getMerchantNames = async () => {
  try {
    const GET_MERCHANT_NAME = gql`
      query AllMerchants {
        allMerchants {
          name
        }
      }
    `;

    const response = await merchantServiceGraphql.request(GET_MERCHANT_NAME);
    return response.allMerchants;
  } catch (err) {
    return null;
  }
};

export const getMerchantHandleToken = async (token) => {
  try {
    const graphQLClient = new GraphQLClient(endPoint, {
      headers: {
        authorization: 'Bearer ' + token,
      },
    });

    const GET_MERCHANT_NAME = gql`
      query AllMerchants {
        allMerchants {
          id
          name
        }
      }
    `;

    const response = await graphQLClient.request(GET_MERCHANT_NAME);
    return response.allMerchants;
  } catch (err) {
    return null;
  }
};

export const updateSubmerchantRoot = async (data) => {
  const UPDATE_SUBMERCHANT = gql`
    mutation UpdateSubMerchant(
      $id: Int!
      $address: String
      $phone: String
      $email: String
      $state: Int
      $city: Int
    ) {
      updateSubMerchant(
        id: $id
        address: $address
        phone: $phone
        email: $email
        state: $state
        city: $city
      ) {
        id
      }
    }
  `;
  const response = await merchantServiceGraphql.request(
    UPDATE_SUBMERCHANT,
    data
  );
  return response.updateSubMerchant;
};

export const updateStatus = async (data, password) => {
  const UPDATE_STATUS_MERCHANT = gql`
    mutation UpdateStatusMerchant(
      $updateStatusMerchantId: Int!
      $status: Int!
    ) {
      updateStatusMerchant(id: $updateStatusMerchantId, status: $status) {
        id
        status
      }
    }
  `;

  const requestHeaders = {
    authorization: userToken,
    Password: password,
  };
  // try {
  const response = await tokenAppGraphql.request(
    UPDATE_STATUS_MERCHANT,
    data,
    requestHeaders
  );
  return response.updateStatusMerchant;
  // }
};

export const GetTariffByContract = async () => {
  const TARIFF = gql`
    query GetTariffByContractId {
      getTariffByContractId {
        domainname
        tarifftype
        tariffrole
        personalisationtype
        tariffname
        tariffstartdate
        tariffvalue
        domainlevel
        id
        contract
        globaltariff
        personaltariff
        tariffdomain
        activetariffdata
        tariffandcontract
        dueperiod
        graceperiod
        currency
        mincount
        maxcount
        minamount
        maxamount
        baseamount
        singleamount
        fxratetype
        ratevalue
        feeratevalue
        applymode
        datefrom
      }
    }
  `;
  const requestHeaders = {
    authorization: userToken,
  };
  const response = await merchantServiceGraphql.request(TARIFF, requestHeaders);
  return response.getTariffByContractId;
};

export const getAllMerchant = async () => {
  const GET_ALL_MERCHANT = gql`
    query AllMerchants {
      allMerchants {
        id
        name
      }
    }
  `;
  const response = await merchantServiceGraphql.request(GET_ALL_MERCHANT);
  return response.allMerchants;
};




export const allIndustries = async() => {
    try {
        const ALL_INDUSTRY = gql`
            query AllIndustries {
                allIndustries {
                id
                content
                }
            }
        `
        const respone = await merchantServiceGraphql.request(ALL_INDUSTRY);
        return respone.allIndustries;
    } catch(err) {
        return null;
    }
}